var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59992 13.185L2.13252 17.5377C1.73138 18.2454 2.2956 19.1158 3.09212 19.018L5.26696 18.7512C5.69656 18.6984 6.10876 18.9408 6.27874 19.3461L7.13924 21.3979C7.45439 22.1493 8.47657 22.2118 8.87771 21.5042L11.1702 17.46C8.34891 17.1867 5.93128 15.5341 4.59992 13.185Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8298 17.46L15.1223 21.5042C15.5234 22.2118 16.5456 22.1493 16.8608 21.3979L17.7213 19.3461C17.8912 18.9408 18.3034 18.6984 18.733 18.7512L20.9079 19.018C21.7044 19.1158 22.2686 18.2454 21.8675 17.5377L19.4001 13.185C18.0687 15.5341 15.6511 17.1867 12.8298 17.46Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16ZM8 8.45681C8 6.03402 10.2001 5.12947 12 7.00105C13.7999 5.12947 16 6.03402 16 8.45679C16 9.90709 14.3922 11.4409 13.2153 12.3695C12.6825 12.7898 12.4161 13 12 13C11.5839 13 11.3175 12.7898 10.7847 12.3695C9.60777 11.4409 8 9.90707 8 8.45681Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge7);
export default __webpack_public_path__ + "static/media/badge-7.001b574519fd4525fac5d43c148f985b.svg";
export { ForwardRef as ReactComponent };